import { render, staticRenderFns } from "./archivePayment.vue?vue&type=template&id=3698b77f&scoped=true"
import script from "./archivePayment.vue?vue&type=script&lang=js"
export * from "./archivePayment.vue?vue&type=script&lang=js"
import style0 from "./archivePayment.vue?vue&type=style&index=0&id=3698b77f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698b77f",
  null
  
)

export default component.exports